/**
 * Especialidades del producto (F2.1, supuesto S-01).
 *
 * Cada especialidad ES un modulo de tipo `especialidad`: contratarla es
 * habilitar ese modulo. La lista se mantiene alineada con el catalogo de
 * modulos y una prueba lo comprueba en los dos sentidos. Oftalmologia, ORL y
 * gastroenterologia entraron en F6.1 a F6.3; obesidad y diabetes, en F6.6.
 */
export const ESPECIALIDADES = [
    'medicina-general',
    'ginecologia-colposcopia',
    'cardiologia',
    'nutricion',
    'oftalmologia',
    'otorrinolaringologia',
    'gastroenterologia',
    'obesologia',
];
export const NOMBRE_DE_ESPECIALIDAD = {
    'medicina-general': 'Medicina general',
    'ginecologia-colposcopia': 'Ginecología y colposcopía',
    cardiologia: 'Cardiología',
    nutricion: 'Nutrición',
    oftalmologia: 'Oftalmología',
    otorrinolaringologia: 'Otorrinolaringología',
    gastroenterologia: 'Gastroenterología',
    obesologia: 'Obesidad y diabetes',
};
export function esEspecialidad(valor) {
    return ESPECIALIDADES.includes(valor);
}
//# sourceMappingURL=especialidades.js.map